export enum MKMediaType {
    Audio = "audio",
    Video = "video"
}